__webpack_require__.p = "/game/grandchaseclassic/drops/";